import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import clsx from 'clsx'
import './Header.css'

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [isDarkMode, setIsDarkMode] = useState(true) // Modo oscuro por defecto
  const location = useLocation()

  // Cargar tema desde localStorage o usar modo oscuro por defecto
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme')
    if (savedTheme) {
      setIsDarkMode(savedTheme === 'dark')
      document.documentElement.setAttribute('data-theme', savedTheme)
    } else {
      // Si no hay tema guardado, usar modo oscuro por defecto
      setIsDarkMode(true)
      document.documentElement.setAttribute('data-theme', 'dark')
      localStorage.setItem('theme', 'dark')
    }
  }, [])

  // Toggle tema oscuro
  const toggleTheme = () => {
    const newTheme = isDarkMode ? 'light' : 'dark'
    setIsDarkMode(!isDarkMode)
    document.documentElement.setAttribute('data-theme', newTheme)
    localStorage.setItem('theme', newTheme)
  }

  // Cerrar menú móvil
  const closeMenu = () => setIsMenuOpen(false)

  // Verificar si la ruta está activa
  const isActive = (path) => location.pathname === path

  return (
    <header className="header">
      <div className="container">
        <div className="header__content">
          {/* Logo */}
          <Link to="/" className="header__logo" onClick={closeMenu}>
            <img src="/logo.jpg" alt="Estudio Contable Vanesa Mondejar" />
            <span className="header__logo-text">
              <strong>Vanesa Mondejar</strong>
              <small>Estudio Contable</small>
            </span>
          </Link>

          {/* Navegación desktop */}
          <nav className="header__nav" aria-label="Navegación principal">
            <ul className="header__nav-list">
              <li>
                <Link 
                  to="/" 
                  className={clsx('header__nav-link', { 'header__nav-link--active': isActive('/') })}
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link 
                  to="/servicios" 
                  className={clsx('header__nav-link', { 'header__nav-link--active': isActive('/servicios') })}
                >
                  Servicios
                </Link>
              </li>
              <li>
                <Link 
                  to="/nosotros" 
                  className={clsx('header__nav-link', { 'header__nav-link--active': isActive('/nosotros') })}
                >
                  Nosotros
                </Link>
              </li>
              <li>
                <Link 
                  to="/contacto" 
                  className={clsx('header__nav-link', { 'header__nav-link--active': isActive('/contacto') })}
                >
                  Contacto
                </Link>
              </li>
            </ul>
          </nav>

          {/* Controles */}
          <div className="header__controls">
            {/* Toggle tema */}
            <button
              className="header__theme-toggle"
              onClick={toggleTheme}
              aria-label={isDarkMode ? 'Cambiar a tema claro' : 'Cambiar a tema oscuro'}
            >
              <img 
                src={isDarkMode ? "/sol.png" : "/luna.png"} 
                alt={isDarkMode ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
                className="header__theme-icon"
              />
            </button>

            {/* Botón WhatsApp */}
            <a
              href="https://wa.me/5491166201346"
              target="_blank"
              rel="noopener noreferrer"
              className="header__whatsapp"
              aria-label="Contactar por WhatsApp"
            >
              📱 WhatsApp
            </a>

            {/* Botón menú móvil */}
            <button
              className="header__menu-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Abrir menú"
              aria-expanded={isMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>

        {/* Menú móvil */}
        <nav 
          className={clsx('header__mobile-nav', { 'header__mobile-nav--open': isMenuOpen })}
          aria-label="Navegación móvil"
        >
          <ul className="header__mobile-nav-list">
            <li>
              <Link 
                to="/" 
                className={clsx('header__mobile-nav-link', { 'header__mobile-nav-link--active': isActive('/') })}
                onClick={closeMenu}
              >
                Inicio
              </Link>
            </li>
            <li>
              <Link 
                to="/servicios" 
                className={clsx('header__mobile-nav-link', { 'header__mobile-nav-link--active': isActive('/servicios') })}
                onClick={closeMenu}
              >
                Servicios
              </Link>
            </li>
            <li>
              <Link 
                to="/nosotros" 
                className={clsx('header__mobile-nav-link', { 'header__mobile-nav-link--active': isActive('/nosotros') })}
                onClick={closeMenu}
              >
                Nosotros
              </Link>
            </li>
            <li>
              <Link 
                to="/contacto" 
                className={clsx('header__mobile-nav-link', { 'header__mobile-nav-link--active': isActive('/contacto') })}
                onClick={closeMenu}
              >
                Contacto
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  )
}

export default Header
